module.exports = __webpack_public_path__ + "img/system34-details.281a805f.png";